import { ComponentPropsWithoutRef, Suspense } from 'react'

import { cn } from '@sparkai/utils'

import { IconsName, LibraryIcons } from '../Icon'
import { AvailableAvatarIcons, AVATAR_ICONS_LIST } from './iconsList'

type CommonProps = {
  color?: string
  iconColor?: string
  size?: number
  iconProps?: ComponentPropsWithoutRef<'svg'>
  fallbackText?: string
  title?: string
} & ComponentPropsWithoutRef<'div'>

export type FileIconProps = CommonProps & {
  icon: AvailableAvatarIcons
  type: 'file'
}

export type LibraryIconProps = CommonProps & {
  icon: IconsName
  type: 'library'
}

export type IconAvatarProps = FileIconProps | LibraryIconProps

export function IconAvatar({
  icon,
  color,
  iconColor,
  size = 40,
  className,
  style,
  type = 'file',
  iconProps,
  fallbackText,
  title,
  ...props
}: IconAvatarProps) {
  const IconComponent =
    type === 'file' ? AVATAR_ICONS_LIST[icon as AvailableAvatarIcons] : LibraryIcons[icon as IconsName]

  const finalIconColor = iconColor ?? 'white'
  return (
    <div
      style={{ width: size, height: size, backgroundColor: color, ...style }}
      className={cn('flex items-center justify-center rounded-full', className)}
      {...props}
    >
      <Suspense>
        {!!IconComponent && (
          <IconComponent
            {...iconProps}
            className={cn('h-full w-full', iconProps?.className)}
            style={{ color: finalIconColor }}
          />
        )}
        {!IconComponent && !!fallbackText && getInitials(fallbackText)}

        {title && <p className='text-sm font-medium text-white'>{title}</p>}
      </Suspense>
    </div>
  )
}

const getInitials = (name: string) => {
  const names = name.split(' ')
  return names
    .map((n) => n.charAt(0).toUpperCase())
    .join('')
    .slice(0, 2)
}
